import LinkToDocusaurus from '../LinkToDocusaurus'
import { daiWebhooks } from '../../docs-routes'

const LinkToWebhookDoc = () =>
  <LinkToDocusaurus path={daiWebhooks}>
    Learn more in the DAI documentation
  </LinkToDocusaurus>

export default LinkToWebhookDoc
